import React, { useEffect } from 'react';
import Navbar from './src/scenes/global/Navbar.js';
import Footer from './src/scenes/global/Footer.js';
import { useLocation } from 'react-router-dom';
import { APP_URLS } from './urls.js';

const Layout = ({ children }) => {
	const location = useLocation();

	// Combined list of routes that shouldn't display the navbar and footer
	const excludedRoutes = [
		APP_URLS.patientRegister,
		'patient_activation_email',
		APP_URLS.patientLogin,
		APP_URLS.patientForgotPassword,
		APP_URLS.patientResetPassword,
		APP_URLS.patientProfileCompletion,
		APP_URLS.patientDashboard,
		APP_URLS.patientUniversalMedicalRecord,
		APP_URLS.patientNotifications,
		APP_URLS.patientRefill,
		APP_URLS.patientReminder,
		APP_URLS.patientProfile,
		APP_URLS.patientAssistant,
		APP_URLS.patientPurchases,
		APP_URLS.patientTreatments,
		APP_URLS.patientShare,
		APP_URLS.patientSettings,
		'/app/home_feed',
		'/app/medi_chat_groups',
		'/app/medi_chat_pages',
		'/app/medi_chat_profile',
		'/app/pharmacy/register',
		'/app/pharmacy/login',
		'/app/pharmacy/dashboardpage',
		'/app/verify-email',
		'/app/reset-password',
		'/app/doctor/register',
		'/app/doctor/login',
		'/app/doctor/forgot/password',
		'/app/hospital/login',
		'/app/hospital/register',
		'/app/hospital/forgot_password',
		'/app/hospital/reset_password',
		'/app/hospital/dashboard',
	];

	// Check if the current route is in the excluded routes
	const isExcludedRoute = excludedRoutes.includes(location.pathname);

	// Google Analytics setup
	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://www.googletagmanager.com/gtag/js?id=G-HR5YMKLYL4';
		script.async = true;
		document.head.appendChild(script);

		// Initialize Google Analytics
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			window.dataLayer.push(arguments);
		}
		gtag('js', new Date());
		gtag('config', 'G-HR5YMKLYL4');

		// Track page views whenever the location changes
		gtag('event', 'page_view', {
			page_path: location.pathname,
			page_title: document.title,
			page_location: window.location.href,
		});

		return () => {
			document.head.removeChild(script);
		};
	}, [location]);

	return (
		<div className="app">
			{!isExcludedRoute && <Navbar />}
			{children}
			{!isExcludedRoute && <Footer />}
		</div>
	);
};

export default Layout;
